// extracted by mini-css-extract-plugin
export default {"banner":"BackgroundBanner_banner__vQJeq"};